// src/pages/Reports/Reports.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SalesReportCard from './cards/SalesReportCard';
import ProfitReportCard from './cards/ProfitReportCard';
import InventoryReportCard from './cards/InventoryReportCard';
import StockPerformanceReportCard from './cards/StockPerformanceReportCard';
import ExpiryReportCard from './cards/ExpiryReportCard';
import LowStockReportCard from './cards/LowStockReportCard';

const Reports = () => {
  return (
    <Box
      sx={{
        width: { sm: '90%', md: '100%' },
        marginLeft: { xs: '8%', sm: '2%', md: '1%' },
        textAlign: 'center',
        p: 2,
        backgroundColor: 'white',
        borderRadius: 1,
      }}
    >
      {/* Header - same placement as History */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '90%',
          margin: 'auto',
          py: '15px',
          pb: '32px',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: {
              xs: '1.6rem',
              sm: '2rem',
              md: '2.5rem',
            },
            fontWeight: 600,
          }}
        >
          Reports
        </Typography>

        <Box />
      </Box>

      {/* Reports grid */}
      <Box
        sx={{
          width: '90%',
          margin: 'auto',
          backgroundColor: '#f9fafb',
          pt: 2,
          pb: 2,
          px: { xs: 1, sm: 2 },
          borderRadius: 2,
          minHeight: 250,
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              lg: 'repeat(2, minmax(0, 1fr))',
            },
            gap: 3,
            alignItems: 'start',
            textAlign: 'left',
          }}
        >
          <SalesReportCard />
          <ProfitReportCard />
          <InventoryReportCard />
          <StockPerformanceReportCard />
          <ExpiryReportCard />
          <LowStockReportCard />
        </Box>
      </Box>
    </Box>
  );
};

export default Reports;